import React, {useEffect, useState} from "react";
import classes from "./styles.module.css";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import ContractsTable from "../../../Components/ContractsTable";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import {NavLink} from "react-router-dom";
import Api from "../../../Api";
import {withAuth} from "../../../hoc/Auth";
import Pagination from "react-js-pagination";
import {MultipleSelect} from "../../../Components/Utils/FieldsHelper";

function ContractsList({token}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filteredProjects, setFilteredProjects] = useState([]);

    const [contracts, setContracts] = useState([])
    const [contractsCount, setContractsCount] = useState(0)
    const [isLoading, setIsLoading] = useState(true)

    const [projects, setProjects] = useState([]);
    const [isLoadingProjects, setIsLoadingProjects] = useState(true);

    useEffect(() => {
        new Api({token}).getProjects().then(
            (r) => {
                setProjects(r);
                setIsLoadingProjects(false);
            }
        );

        new Api({token}).getListMetalContracts({
            projects: filteredProjects,
            page: currentPage,
            itemsPerPage: itemsPerPage
        }).then((data) => {
            setContracts(data.data ? data.data : [])
            setContractsCount(data.count ? data.count : 0)
            setIsLoading(false)
        })

    }, []);

    function setPage(page, itemsPerPage) {
        if (page)
            setCurrentPage(page);
        else
            setCurrentPage(1);

        if (itemsPerPage)
            setItemsPerPage(itemsPerPage)

        new Api({token}).getListMetalContracts({
            projects: filteredProjects,
            page: page,
            itemsPerPage: itemsPerPage
        }).then((data) => {
            setContracts(data.data ? data.data : [])
            setContractsCount(data.count ? data.count : 0)
        })
    }

    function applyFilters() {
        setIsLoading(true);
        new Api({token}).getListMetalContracts({
            projects: filteredProjects,
            page: currentPage,
            itemsPerPage: itemsPerPage
        }).then((data) => {
            setContracts(data.data ? data.data : [])
            setContractsCount(data.count ? data.count : 0)
        }).finally(() => {
            setIsLoading(false);
        })
    }

    return (
        <Wrapper>
            <Container className={classes.StackOnMobile}>
                <Column width="780" className={classes.MainColumn}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>Список контрактов</h5>
                        </div>

                        <div className={classes.TableWrap}>
                            <ContractsTable data={contracts} projects={projects} isLoading={isLoading}/>
                        </div>
                        <div className={classes.PaginationWrap}>
                            <Pagination
                                firstPageText="⇤"
                                prevPageText="⇠"
                                lastPageText="⇥"
                                nextPageText="⇢"
                                activeLinkClass={classes.ActiveLink}
                                activePage={currentPage}
                                itemsCountPerPage={itemsPerPage}
                                totalItemsCount={contractsCount}
                                pageRangeDisplayed={10}
                                onChange={(page) => setPage(page, itemsPerPage)}
                            />
                        </div>
                    </div>
                </Column>

                <Column width="350" className={classes.SideColumn}>
                    <EmptyCard>
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal/contract/create`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.contractCreate"}
                                        icon={"share"}
                                        color={"#3cc23a"}
                                    />
                                </NavLink>
                            </li>

                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal/pca`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.pcaList"}
                                        icon={"share"}
                                        color={"#474545"}
                                    />
                                </NavLink>
                            </li>
                        </ul>
                    </EmptyCard>

                    <EmptyCard>
                        <MultipleSelect
                            label={"FieldsHelper.label.project"}
                            placeholder={"FieldsHelper.label.selectProject"}
                            values={projects}
                            selectedValues={filteredProjects}
                            isLoading={isLoadingProjects}
                            onChange={(data) => setFilteredProjects(data)}
                            excludeSearchColumn={[]}
                        />
                    </EmptyCard>
                    <EmptyCard>
                        <Button onClick={applyFilters} label="TransactionsFilters.btn.setFilters" icon="filter"
                                iconSize={'17px'} isLoading={isLoading}/>
                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default withAuth(ContractsList);



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/ContractsList/index.js